import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { TabsInfoItem } from 'entities/tour/ui/tour-detail/components/tabs-info/components/about-tour/components/tabs-info-item'

import { HotelServices } from 'shared/api/tours/search'
import { getValidIcon } from 'shared/lib/validateIcon.ts'
import { AllIcons } from 'shared/ui/app-icon/types.ts'

import s from './styles.module.scss'

interface Props {
  services: HotelServices[]
}

export const HotelInfoPopup: FC<Props> = ({ services }) => {
  const { t } = useTranslation()
  return (
    <div className={s.tabsInfoListPopup}>
      <h4 className={clsx('bold-22', s.title)}>
        <span>❤</span> {t('tours_block.hotel_comfort')}
      </h4>
      {services.map((i) => (
        <>
          <p className="bold-18">{i.services_name}</p>
          <div className={s.tabsInfoList}>
            {i.services_value.map((item, index) => (
              <TabsInfoItem
                key={index}
                title={item.value}
                icon={getValidIcon(item.icon as AllIcons)}
              />
            ))}
          </div>
        </>
      ))}
    </div>
  )
}
